import styled from 'styled-components';

export const Wrapper = styled.div`
  i {
    font-size: 30px;
  }
`;
